export const model = {
    id: null,
    slug: '', 
    parent_id: null,
    has_child: false,
    active: true,
    created_at: '',
    updated_at: '',
  };
